import type { CSSProperties, ReactNode } from 'react';

/** The standard white surface card (hairline border, flat by rest — Ledger). */
export const card: CSSProperties = {
  background: 'var(--color-white)',
  border: '1px solid var(--color-border)',
  borderRadius: 'var(--radius-md)',
  boxShadow: 'var(--shadow-card)',
};

/** Card with padding + optional overflow (auto for scrollable tables). */
export function cardPad(padding: number | string = 20, overflow?: CSSProperties['overflow']): CSSProperties {
  return { ...card, padding, ...(overflow ? { overflow } : {}) };
}

/** Uppercase table-header cell, matching the original <th> styling. */
export function Th({ children, align = 'left', pad = '11px 14px' }: { children?: ReactNode; align?: 'left' | 'right' | 'center'; pad?: string }) {
  return (
    <th style={{ textAlign: align, padding: pad, fontSize: 10, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>
      {children}
    </th>
  );
}

/** Rounded status chip. */
export function Chip({ children, bg, fg, dot }: { children: ReactNode; bg: string; fg: string; dot?: boolean }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: bg, color: fg }}>
      {dot && <span style={{ width: 6, height: 6, borderRadius: 999, background: fg }} />}
      {children}
    </span>
  );
}

/** Section heading used inside cards. */
export function CardTitle({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return <div style={{ fontWeight: 700, marginBottom: 14, ...style }}>{children}</div>;
}
